<div class="container">
  <div class="row">
    <div class="col-3"></div>
    <div class="col-6 folat-end">
      <button type="button" class="btn btn-primary" (click)="open(content)">Add New Service Type</button>
    </div>
    <div class="col-3"></div>
  </div>
  <br>
    <div class="row">
      <div class="col-3"></div>
      <div class="col-6 table-responsive text-center">
        <table class="table table-bordered">
          <thead>
            <tr class="header-color">
              <th>#</th>
              <th>Name</th>
              <th>Description</th>
              <th>Price</th>
              <!-- <th>Discount</th> -->
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (list_length == 0) {
              <tr>
                <td colspan="6">No data found</td>
              </tr>
            }
            @for (item of items | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; track item; let i = $index) {
              <tr
                >
                <td>{{ ((page-1) * pageSize) + (i+1) }}</td>
                <td style="text-align: left;">{{item?.name}}</td>
                <td style="text-align: left;">{{item?.description}}</td>
                <td>{{item?.price}}</td>
                <!-- <td>{{item?.discount}}</td> -->
                <td>
                  <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                    style="direction:ltr">
                    <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-danger"
                    (click)="onDelete(item.id)">Delete</button>
                    <button type="button" class="btn btn-secondary"
                    (click)="edit(content2, item)">Update</button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <ngb-pagination [collectionSize]="items.length" [(page)]="page" [maxSize]="5" [rotate]="true"
        [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
      </div>
      <div class="col-3"></div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Add New Service Type</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="name">Name</label>
        <input type="text" class="form-control" [(ngModel)]="item.name" id="name">
      </div>
      <div class="mb-3">
        <label for="description">Description</label>
        <input type="text" class="form-control" [(ngModel)]="item.description" id="description">
      </div>
      <div class="mb-3">
        <label for="price">Price</label>
        <input type="number" class="form-control" [(ngModel)]="item.price" id="price">
      </div>
      <!-- <div class="mb-3">
      <label for="discount">Discount</label>
      <input type="number" class="form-control" [(ngModel)]="item.discount" id="discount">
    </div> -->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="OnSubmit()">Add</button>
  </div>
</ng-template>
<ng-template #content2 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Update Setting Item</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label for="name">Name</label>
      <input type="text" class="form-control" [(ngModel)]="new_item.name" id="name">
    </div>
    <div class="mb-3">
      <label for="description">Description</label>
      <input type="text" class="form-control" [(ngModel)]="new_item.description" id="description">
    </div>
    <div class="mb-3">
      <label for="price">Price</label>
      <input type="number" class="form-control" [(ngModel)]="new_item.price" id="price">
    </div>
    <!-- <div class="mb-3">
    <label for="discount">Discount</label>
    <input type="number" class="form-control" [(ngModel)]="new_item.discount" id="discount">
  </div> -->
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="OnUpdate(update_key)">Update</button>
</div>
</ng-template>